//https://assets.hongkiat.com/uploads/ww-pattern-wallpapers/folds.jpg
import React from 'react';
import './Home.css';

const Banner=()=>{
    return(
        <React.Fragment>
           <div className="banner lemo-font">
               <div>
                    <h1>مركز المهندس لصيانة السيارات</h1>
                    <h1>خبرة اكثر من عشرين عام </h1>
               </div>
           </div>
        </React.Fragment>    
    );
}
export default Banner;


// WEBPACK FOOTER //
// ./src/components/home/Banner.js